const facilities = [
  {
    name: "Idaho Falls Main Post Office",
    address: "485 Park Ave, Idaho Falls, ID 83402",
    phone: "(208) 529-4340",
    hours: "Mon–Fri 8:30am–5:00pm",
    note: "Passport acceptance by appointment",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Idaho Falls East Post Office",
    address: "1970 Channing Way, Idaho Falls, ID 83404",
    phone: "(208) 529-4340",
    hours: "Mon–Fri 9:00am–5:00pm",
    note: "Walk-in passport acceptance available",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Bonneville County Clerk's Office",
    address: "605 N Capital Ave, Idaho Falls, ID 83402",
    phone: "(208) 529-1350",
    hours: "Mon–Fri 8:00am–5:00pm",
    note: "Official acceptance facility for all passport types",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Ammon City Hall",
    address: "2135 S Ammon Rd, Ammon, ID 83406",
    phone: "(208) 612-4000",
    hours: "Mon–Fri 8:00am–5:00pm",
    note: "Passport services available — call ahead",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Rexburg Post Office",
    address: "118 E 4th S, Rexburg, ID 83440",
    phone: "(208) 356-5534",
    hours: "Mon–Fri 9:00am–5:00pm",
    note: "Passport acceptance service available",
    website: "https://tools.usps.com/find-location.htm",
  },
  {
    name: "Blackfoot Post Office",
    address: "12 N Meridian St, Blackfoot, ID 83221",
    phone: "(208) 785-3810",
    hours: "Mon–Fri 8:30am–5:00pm",
    note: "Accepts passport applications",
    website: "https://tools.usps.com/find-location.htm",
  },
];

export default function AcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Idaho Falls
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            New applicants and minors must appear in person at a passport acceptance facility. Renewals can be handled entirely by mail. Here are locations near Idaho Falls.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {facilities.map((f, i) => (
            <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-5">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-building-line text-[#1A365D]"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm leading-tight">{f.name}</h3>
                  {f.note && <span className="inline-block bg-[#1A365D] text-white text-xs px-2 py-0.5 rounded-full mt-1 whitespace-nowrap">{f.note}</span>}
                </div>
              </div>
              <div className="space-y-1.5">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-map-pin-line text-gray-400 flex-shrink-0"></i>
                  <span>{f.address}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-phone-line text-gray-400 flex-shrink-0"></i>
                  <span>{f.phone}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <i className="ri-time-line text-gray-400 flex-shrink-0"></i>
                  <span>{f.hours}</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <i className="ri-global-line text-[#F6C344] flex-shrink-0"></i>
                  <a
                    href={f.website}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-[#1A365D] font-medium hover:text-[#F6C344] transition-colors underline underline-offset-2"
                  >
                    Visit website
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-[#EEF2F8] border border-[#1A365D]/10 rounded-lg p-5 text-sm text-[#1A365D]">
          <i className="ri-information-line mr-2"></i>
          <strong>Tip:</strong> For renewals, you can skip the acceptance facility entirely — just mail your documents directly to us. Only first-time applicants and children under 16 must appear in person.
        </div>
      </div>
    </section>
  );
}